export default __webpack_public_path__ + "components/weather-icon/static/nightrainshowers-155344e3bfe22be269250958e206238f.png";